import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideoSlash } from "@fortawesome/free-solid-svg-icons";

/**
 * Component for the main remote video view (Applicant or CM).
 * Displays a fallback image if the video stream is not active.
 */
export const RemoteVideoView = ({
  remoteRef,
  remoteVideoActive,
  isRemoteVideoOn,
  isAdminOrCM,
}) => {
  const showFallback = !remoteVideoActive || !isRemoteVideoOn;

  return (
    <div className="w-full aspect-video bg-black border-2 border-black rounded-2xl flex items-center justify-center shadow-sm overflow-hidden relative">
      <video
        ref={remoteRef}
        autoPlay
        playsInline
        className={`w-full h-full object-cover ${!showFallback ? "block" : "hidden"}`}
      />
      {showFallback && (
        <div className="w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-gray-800 to-black">
          <FontAwesomeIcon
            icon={faVideoSlash}
            className="text-white mb-4"
            style={{ fontSize: "5rem" }}
          />
          <span className="text-white text-sm font-medium">
            {!remoteVideoActive
              ? "Waiting for remote user..."
              : "Camera is off"}
          </span>
        </div>
      )}
      <span className="absolute bottom-2 left-2 md:bottom-4 md:left-4 text-xs md:text-xl font-medium text-black bg-white/70 px-2 py-0.5 md:px-4 md:py-1 rounded-full z-10">
        {isAdminOrCM ? "Applicant Face" : "CM Face"}
      </span>
    </div>
  );
};
